// import { css } from 'emotion';
import React, { useState, useEffect, Fragment } from 'react';
// import "./Hubspot.scss"

function HubspotFormContainer({elementID, region, formID, portalID})  {

    const [scriptLoaded, setScriptLoaded] = useState(window.hbspt ? true : false)

    const targetId = `hubspotForm-${formID}-${elementID}` 

    useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/v2.js";

      document.body.appendChild(script)
      script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: region,
          portalId: portalID,
          formId: formID,
          target: `#${targetId}`,
          // cssRequired:".hs-form-field label:not(.hs-error-msg){color:white !important} .submitted-message{ color: $white !important; } "
        });
        setScriptLoaded(true)
      } 
    });
    }, []);

    return (
      <Fragment>
        {scriptLoaded ? 
          <div id={targetId} className={`hubspot-form-container`}></div> : 
          <p>Form Loading...</p>
        }
      </Fragment>
    );
}

export default HubspotFormContainer;